// supervisor-mission-run-release-flow-and-final-label.ts
//
// Tách khỏi supervisor-mission-run.ts (review 03a L6: file mẹ 198/200 dòng).
// Bước CUỐI của `run` sau vòng ticket: resume release flow (nếu có), journal
// câu trả lời của flow, rồi ghi nhãn mission. Chuyển nguyên văn, không đổi
// hành vi.
import { randomUUID } from "node:crypto";
import { missionStatusLabelAfterRun } from "./mission-status-label-after-run.js";
import type { MissionStore } from "./mission-store.js";
import { journalReleaseFlowOutcome } from "./release-flow-resume-observability.js";
import type { AutopilotConfig } from "./schemas/config-schema.js";
import type { RunMissionInput, RunMissionResult } from "./supervisor-mission-run-types.js";
import { maybeResumeReleaseFlowAfterDone } from "./supervisor-release-flow-resume.js";
import type { RunUntilIdleResult } from "./supervisor-run-until-idle.js";

export async function finishRunWithReleaseFlowAndFinalLabel(input: {
  run: RunMissionInput;
  store: MissionStore;
  config: AutopilotConfig;
  executionRepo: string;
  result: RunUntilIdleResult;
}): Promise<RunMissionResult> {
  const { run, store, result } = input;
  // Bug G fix: resumes REVIEWING -> ... -> DONE. Idempotent via
  // gates.json — safe across separate `run` calls (before/after `approve g3`).
  const releaseFlow = await maybeResumeReleaseFlowAfterDone({
    ticketLoopOutcome: result.outcome,
    config: input.config,
    store,
    controlRoot: run.controlRoot,
    missionId: run.missionId,
    repoDir: input.executionRepo,
    resumeInputFactory: run.releaseFlowResumeInputFactory,
  });
  // P24: journal the flow's answer (it was read by nobody; console line in run-command-cli-wiring.ts).
  if (releaseFlow) await journalReleaseFlowOutcome(store, releaseFlow);
  // Bug I (P15): journal WHY a gate block stopped the run (`blocked:<code>`, as §18).
  // Re-review 2026-09-26: a clean finish journals a label too (H14, see
  // missionStatusLabelForReleaseFlow); X4: a stale gate label is replaced.
  const label = missionStatusLabelAfterRun({
    currentStatus: store.state.status,
    outcome: result.outcome,
    gateBlocked: result.gateBlocked,
    releaseFlow,
  });
  if (label) {
    await store.commit([
      { event_id: randomUUID(), delta: { kind: "mission_status_changed", status: label } },
    ]);
  }
  return { ...result, releaseFlow };
}
